// This must be the first line in src/index.js
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./components/App";
//import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById("focus"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();
/* Required Packages for this application
npm install @material-ui/core
npm install react-autocomplete
npm install react-cookies
npm install react-html-parser
npm install react-keyboard-event-handler
npm install react-reveal
npm install react-scroll-up-button
npm install react-scrollable-anchor
npm install react-swipeable
*/
